import { INPUT_WIDTHS_EDITOR_CONDITION } from '../../constants/inlineLayout';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { useConditionInputs } from '../../hooks/useConditionInputs';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { useStrategy } from '../../hooks/useStrategy';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import EditorCondition from './EditorCondition';
import EditorConditionValueInput from './EditorConditionValueInput';
import EditorAssetAndPropertySelect from './EditorAssetAndPropertySelect';
import EditorIncludeObjectsWithNoValueSetInput from './EditorIncludeObjectsWithNoValueSetInput';
import InlineContainerWithEditorConditionActions from '../common/InlineContainerWithEditorConditionActions';
import UISelect from 'UIComponents/input/UISelect';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import UpdateFilterWithExternalOptionsNotification from '../operator/UpdateFilterWithExternalOptionsNotification';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { ENUMERATION, STRING } from 'customer-data-objects/property/PropertyTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NO_WRAP_PROPERTY_TYPES = [ENUMERATION, STRING];
const EditorConditionResponsive = ({
  condition,
  conditionPath,
  filterFamily,
  isFirst
}) => {
  var _condition$field;
  const {
    width
  } = useElementSize();
  const {
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionFieldChange,
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(filterFamily, conditionPath, condition);
  const {
    isIncludeObjectsWithNoValueSetCheckboxEnabled
  } = useStrategy();
  const {
    canFilterBeConverted,
    handleUpdateClick,
    isOperatorIncompatible,
    onSelectedOptionChange,
    operatorOptions
  } = useConditionInputs({
    condition,
    filterFamily,
    onConditionOperatorChange: onFieldConditionOperatorChange,
    onConditionValueChange: onFieldConditionValueChange
  });
  if (!condition.field) {
    return null;
  }
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorCondition, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      isFirst: isFirst
    });
  }
  return /*#__PURE__*/_jsxs(ConditionBox, {
    children: [/*#__PURE__*/_jsxs(InlineContainerWithEditorConditionActions, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      hideChangeFieldButton: true,
      wrap: !NO_WRAP_PROPERTY_TYPES.includes((_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.type),
      onConditionDelete: () => onConditionDelete(conditionPath),
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          alignSelf: 'start',
          width: `${INPUT_WIDTHS_EDITOR_CONDITION[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(EditorAssetAndPropertySelect, {
          field: condition.field,
          filterFamily: filterFamily,
          onChange: onFieldConditionFieldChange
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          alignSelf: 'start',
          flexShrink: 0,
          width: `${INPUT_WIDTHS_EDITOR_CONDITION[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(UISelect, {
          "data-onboarding": "filter-condition-select-field",
          "data-selenium-test": "fr-filter-operator-select",
          "data-test-id": "fr-filter-operator-select",
          disabled: isOperatorIncompatible,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          readOnly: operatorOptions.length === 1,
          value: condition.constructor.toString()
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          alignSelf: 'start',
          minWidth: `${INPUT_WIDTHS_EDITOR_CONDITION[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
          condition: condition,
          filterFamily: filterFamily,
          onChange: onFieldConditionValueChange,
          size: "md"
        })
      })]
    }), isIncludeObjectsWithNoValueSetCheckboxEnabled && /*#__PURE__*/_jsx(EditorIncludeObjectsWithNoValueSetInput, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      onChange: onFieldConditionValueChange,
      spaceStyleProps: {
        marginBlockStart: '200'
      }
    }), isOperatorIncompatible && /*#__PURE__*/_jsx(UpdateFilterWithExternalOptionsNotification, {
      onUpdateClick: handleUpdateClick,
      canFilterBeConverted: canFilterBeConverted
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    })]
  });
};
export default EditorConditionResponsive;